export default __webpack_public_path__ + "static/media/priyanka_docs.db22c1f6.jpeg";